
import type { Facet, Filter, HierarchicalFilter } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { EpbBadge } from '../../shared/epb-badge'
import XTogglePanel from '../x-toggle-panel.component.vue'
import XFiltersList from './x-filters-list.component.vue'

export default defineComponent({
  name: 'Facet',
  components: {
    XTogglePanel,
    EpbBadge,
    XFiltersList,
  },
  props: {
    facet: {
      type: Object as PropType<Facet>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-facet',
    }
  },
  computed: {
    numSelectedFilters(): number {
      const countFacetSelectedFilters = (result: number, filter: Filter): number => {
        if (filter.selected && !(filter as HierarchicalFilter).parentId) {
          result++
        }
        return result
      }
      return this.facet.filters.reduce(countFacetSelectedFilters, 0)
    },
  },
})
